/**
 * Curtain Scroll Effect - Vision over Hero and Equipe over Hero
 */

export function initCurtainScroll() {
  const heroSection = document.querySelector('.acc_hero');
  const equipeSection = document.querySelector('.acc_equipe');
  const visionSection = document.querySelector('.acc_vision');
  
  if (!heroSection || !equipeSection) return;
  
  // Create a style element for important styles
  const styleElement = document.createElement('style');
  styleElement.id = 'curtain-scroll-styles';
  document.head.appendChild(styleElement);
  
  // Function to update styles based on scroll position
  function updateScrollEffects() {
    const equipeRect = equipeSection.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    let styles = '';
    
    // Check if equipe section is in viewport (top of equipe section reaches middle of viewport)
    if (equipeRect.top <= viewportHeight * 0.5) {
      // Apply z-index: -2 !important to hero section
      styles += '.acc_hero { z-index: -2 !important; }';
    }
    
    // Check if we've reached the end of vision section
    if (visionSection) {
      const visionRect = visionSection.getBoundingClientRect();
      // Hide logo when vision section's bottom is above viewport middle
      if (visionRect.bottom <= viewportHeight * 0.2) {
        styles += ' .acc_hero__logo { display: none !important; }';
      }
    }
    
    // Apply all styles
    styleElement.textContent = styles;
  }
  
  // Throttle function for better performance
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateScrollEffects();
        ticking = false;
      });
      ticking = true;
    }
  }
  
  // Initial check
  updateScrollEffects();
  
  // Listen for scroll events
  window.addEventListener('scroll', handleScroll);
  
  // Also update on resize
  window.addEventListener('resize', updateScrollEffects);
  
  // Cleanup function for potential removal
  return function cleanup() {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('resize', updateScrollEffects);
    const style = document.getElementById('curtain-scroll-styles');
    if (style) style.remove();
  };
}